import { getUserLocale } from '@empiriecom/module-components/IntlProvider';
import { RatingReview } from '@/interfaces/Rating';

export const createPreviewRating = (
  name: string,
  city: string,
  value: number,
  review: string,
  headline: string,
  advantageTags: string[],
  disadvantageTags: string[],
): RatingReview => {
  const date = new Date();
  const month = `0${date.getMonth() + 1}`.slice(-2); // months from 1-12, slice for adding preceding zeros if needed
  const day = `0${date.getUTCDate()}`.slice(-2); // slice for adding preceding zeros if needed
  const year = date.getUTCFullYear();

  const createdDate = `${day}.${month}.${year}`;

  const previewRating: RatingReview = {
    availableTags: null,
    created: createdDate,
    description: review,
    helpful: null,
    helpfulRatingsCnt: 0,
    id: null,
    lastModified: null,
    locale: null,
    moderationTags: [],
    notAppropriateRatingsCnt: 0,
    notHelpfulRatingsCnt: 0,
    rating: value,
    responses: null,
    reviewTags: {
      contraTags:
        disadvantageTags.length > 0
          ? disadvantageTags.map((tag, index) => ({
              id: tag.concat(index.toFixed()),
              key: null,
              name: tag,
              type: 'contra',
              userDefined: null,
            }))
          : null,
      hasContra: disadvantageTags.length > 0,
      hasPro: advantageTags.length > 0,
      proTags:
        advantageTags.length > 0
          ? advantageTags.map((tag, index) => ({
              id: tag.concat(index.toFixed()),
              key: null,
              name: tag,
              type: 'pro',
              userDefined: null,
            }))
          : null,
    },
    reviewer: { email: null, id: null, location: city, nickname: name },
    shareable: null,
    sourceClient: null,
    status: null,
    subRatingValues: [],
    tags: null,
    title: headline,
  };
  return previewRating;
};

export const createSubmitRating = (
  sku: string,
  ratingValue: number,
  title: string = '',
  review: string,
  name: string,
  city: string = '',
  advantageTags: string[] = [],
  disadvantageTags: string[] = [],
) => {
  const mappedAdvantageTags =
    advantageTags.length > 0
      ? advantageTags.map((advTag) => ({ key: 'userdefined', name: advTag, type: 'pro' }))
      : null;

  const mappedDisadvantageTags =
    disadvantageTags.length > 0
      ? disadvantageTags.map((disAdvTag) => ({
          key: 'userdefined',
          name: disAdvTag,
          type: 'contra',
        }))
      : null;

  let tagArray = [];
  if (mappedAdvantageTags !== null) {
    tagArray = tagArray.concat(mappedAdvantageTags);
  }
  if (mappedDisadvantageTags !== null) {
    tagArray = tagArray.concat(mappedDisadvantageTags);
  }

  return {
    'custom-advantage': null,
    'custom-disadvantage': null,
    dataSecurity: 'true',
    description: review,
    isRecommended: false,
    locale: getUserLocale().replace('-', '_'),
    productSku: sku,
    rating: ratingValue.toFixed(),
    recommended: 'no',
    reviewer: {
      email: 'example@batman.com',
      location: city !== '' ? city : null,
      nickname: name,
    },
    subratings: [],
    tags: tagArray,
    title: title !== '' ? title : null,
  };
};
